<template>
    <section class="app-spa">
        <section class="app-spa__box">
            <section class="app-spa__box__logo">
                <img :src="$appConfig.logo.path" :alt="$appConfig.logo.alt" />
            </section>
            <section class="app-spa__box__form">
                <h1 class="app-spa__box__form__header">{{$t('com.file.user-reset-password.reset-password')}}</h1>
                <section class="app-spa__box__form__wrapper" v-if="!isDone">
                    <p class="app-spa__box__form__text">
                        {{$t('com.file.user-online.input-your-email-account')}} <br /> {{$t('com.file.user-online.get-personal-link')}}
                    </p>
                    <section class="app-spa__box__form__row">
                        <label for="user-email" class="app-spa__box__form__label">{{$t('com.file.import-concatc-summary.email')}}</label>
                        <input type="email"
                               name="user-email"
                               id="user-email"
                               class="app-spa__box__form__input"
                               v-model="request.email"
                               :placeholder="$t('com.file.user-forgot-password.input-your-email-placeholder')"
                               autocomplete="off"
                               @keyup.enter="getResetPassword" />
                    </section>
                    <ReCaptchaComponent v-model="request.captchaToken" />
                    
                    <section >
                        <button type="button"
                                class="app-spa__box__form__bottom-button"
                                @click="backToLoginPage">
                            {{$t('com.file.user-forgot-password.back-to-login')}}
                        </button>

                        <button type="button"
                                class="app-spa__box__form__bottom-button app-spa__box__form__bottom-button--red"
                                :disabled="request.captchaToken === '' || request.email === ''"
                                @click="getResetPassword">
                            {{$t('com.file.user-forgot-password.reset-password')}}
                        </button>
                    </section>

                </section>
                <section v-else class="app-spa__box__form__text">
                    {{$t('com.file.user-forgot-password.reset-info-1')}} <br /> {{$t('com.file.user-forgot-password.reset-info-2')}}
                </section>
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
    import ReCaptchaComponent from "../../../BasicControls/ReCaptchaComponent.vue";
    import UserService from "../../../../services/user.service";

    export default {
        name: "UserForgotPassword",
        components: {
            ReCaptchaComponent 
        },
        computed: {
            
        },
        data() {
            return {
                request: {
                    email: "",
                    captchaToken: "",
                },

                isDone: false,

                recaptchaSettings: {
                    siteKey: '6LdriHonAAAAADnpvtlDnDjWY0wdv8wv-27uxYHp',
                    showRecaptcha: true,
                    loadingTimeout: 30000 // 30 seconds
                }
            }
        },
        mounted() {
        },
        methods: {
            async getResetPassword() {
                try {
                    this.isDone = false;
                    this.$store.commit("showLoader");
                    await UserService.forgotPasswordRequest(this.request);
                }
                finally {
                    this.$store.commit("hideLoader");
                    this.isDone = true;
                }
            },
            backToLoginPage() {
                this.$router.push({ name: 'Login' });
            }
        }
    }
</script>
<style lang="scss" scoped>
    @use  "~@/assets/scss/esesja-app-spa.scss";
    .app-spa__box__form__wrapper {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
    }
    .app-spa__box{
        max-width: 1024px;
    }
</style>